const BrokerAPI = {
  broker: {
    request_approval: '/brokers/request_approval',
    list: '/brokers',
    detail: '/brokers/:id',
    approve: '/brokers/:id/approve',
    reject: '/brokers/:id/reject',
    sub_member: '/brokers', //cấp dưới trực tiếp ?higher_broker_id=
    customer_services: '/brokers/:id/customer_services', //yêu cầu tư vấn ?type=consultation, type=under_care // khách hàng đang chăm sóc type=flash_offer // flash offer đang tham gia
    consultations: 'consultations',
    flash_offers_by_broker: '/real_estate/flash_offers',
  }

}

export default BrokerAPI